import { useState } from "react";
import { useSharedState } from "state";
import { AuthPayload } from "types/user";
import { authenticateUser } from "api/auth";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import LogoTitle from "assets/img/dock_title.png";

export default function SignIn() {
  const { setHash, notify } = useSharedState();

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isFormLoading, setFormLoading] = useState<boolean>(false);

  const onAuthorize = async (e: any) => {
    e.preventDefault();

    try {
      setFormLoading(true);
      const res: AuthPayload = await authenticateUser({ username, password });

      localStorage.setItem("hash", res.result.hashed_password);
      setHash(res.result.hashed_password);
      notify("Авторизация прошла успешно", "success");
    } catch (error: any) {
      let err = JSON.stringify(error?.response?.data?.detail);
      notify(err, "danger", "Ошибка при авторизации");
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <div className="page page-center">
      <div className="container container-tight py-4" style={{ width: 450 }}>
        <div className="flex justify-center mb-4">
          <div className="self-center w-28">
            <img className="object-contain" src={LogoTitle} />
          </div>
        </div>
        <div className="card card-md">
          <div className="card-body">
            <h2 className="h2 text-center mb-4">Войдите в свой аккаунт</h2>
            <form autoComplete="off" noValidate>
              <div className="mb-3">
                <label className="form-label">Логин</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ваш логин"
                  autoComplete="off"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  disabled={isFormLoading}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Пароль</label>
                <div className="input-group input-group-flat">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Ваш пароль"
                    autoComplete="off"
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={isFormLoading}
                  />
                  <span className="input-group-text">
                    <div className="link-secondary cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? <IconEyeOff className="icon" /> : <IconEye className="icon" />}
                    </div>
                  </span>
                </div>
              </div>
              <div className="form-footer">
                <button className="btn btn-primary w-100 d-flex gap-1" onClick={onAuthorize} disabled={isFormLoading}>
                  Войти
                  {isFormLoading && <div className="spinner-border spinner-border-sm" role="status" />}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
